import { required, minLength, requiredIf } from 'vuelidate/lib/validators';

const validations = {
  subject: {
    required,
  },
  receiverIds: {
    required: requiredIf(function() {
      return this.companyId !== 0;
    }),
    minLength: function() {
      return this.companyId !== 0 ? minLength(1) : () => true;
    }
  },
  systemMessageType: {
    required,
  },
  content: {
    required,
  },
};

export default validations;
